import { renderToStaticMarkup } from "react-dom/server"

const wrapReportHtml = (content) => {
  return (
    `<!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
        <style>
          * {
            font-family: Roboto, monospace !important;
          }
          @page {
            @top-center {
              content: element(pageHeader);
            }
          }
          #pageHeader {
            position: running(pageHeader);
          }
        </style>
      </head>
      <body>
      ${renderToStaticMarkup(content)}
      </body>
    </html>
    `
  )
}

export default wrapReportHtml;
